import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "space-y-4 overflow-y-auto" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.user_multi_select')
};
import { computed, onMounted, ref } from 'vue';
import { isValidEmail } from '@/helpers/emails';
import { searchTermToUser } from '@/helpers/users';
import TextField from '@/components/base/forms/TextField.vue';
import UserDropdown from '@/components/UserDropdown.vue';
import { FEATURE_FLAGS } from '@/constants';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'UserMultiSelect',
    props: {
        disallowExternalToWorkspace: { type: Boolean, default: false },
        disallowExternalToWorkspacePlaceholder: { type: Boolean, default: false },
        users: null,
        size: null,
        searchTerm: null
    },
    emits: ['selection', 'update:searchTerm'],
    setup(__props, { emit }) {
        const props = __props;
        const isPricingEnabled = FEATURE_FLAGS.PRICING_ENABLED;
        const emailError = ref(false);
        const isSeatsAvailableErrorVisible = ref(false);
        const userSelect = ref(null);
        const popoverOpen = ref(false);
        const handleBlur = () => {
            if (email.value.length > 0 && !isValidEmail(email.value) && !popoverOpen.value) {
                emailError.value = true;
            }
            popoverOpen.value = false;
        };
        const handleFocus = () => userSelect.value.$el.focus();
        const handleInput = () => {
            emailError.value = false;
            isSeatsAvailableErrorVisible.value = false;
            if (props.searchTerm.length < 1) {
                popoverOpen.value = false;
            }
            else {
                popoverOpen.value = true;
            }
        };
        onMounted(() => handleFocus());
        const email = computed(() => props.searchTerm.trim().toLowerCase());
        const filteredUsers = computed(() => {
            return props.users.filter((user) => user.name.toLowerCase().includes(email.value) ||
                user.email.toLowerCase().includes(email.value));
        });
        const clearInput = () => {
            emit('update:searchTerm', '');
            emailError.value = false;
            isSeatsAvailableErrorVisible.value = false;
        };
        const addManually = () => {
            if (!isValidEmail(email.value)) {
                emailError.value = true;
                handleFocus();
                return;
            }
            if (props.disallowExternalToWorkspace && !hasAlreadyJoined(email.value) && isPricingEnabled) {
                isSeatsAvailableErrorVisible.value = true;
                handleFocus();
                return;
            }
            const user = searchTermToUser(email.value, props.users);
            if (user) {
                emit('selection', user);
            }
            clearInput();
            handleFocus();
        };
        const memberSelected = (member) => {
            emit('selection', member);
            clearInput();
        };
        const handleModelValue = (value) => {
            emit('update:searchTerm', value);
        };
        function hasAlreadyJoined(email) {
            return props.users.map((user) => user.email).includes(email);
        }
        return (_ctx, _cache) => {
            const _component_v_popover = _resolveComponent("v-popover");
            const _directive_close_popover = _resolveDirective("close-popover");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_component_v_popover, {
                    placement: "bottom-start",
                    "popover-inner-class": `bg-white rounded-md dark:bg-gray-600 shadow-tile ${__props.size === 'sm' ? 'w-81' : 'w-150'}`,
                    "popover-arrow-class": "hidden",
                    trigger: "manual",
                    disabled: _unref(filteredUsers).length === 0 || !popoverOpen.value,
                    open: _unref(filteredUsers).length > 0 && popoverOpen.value,
                    "auto-hide": false
                }, {
                    popover: _withCtx(() => [
                        _withDirectives(_createVNode(UserDropdown, {
                            users: _unref(filteredUsers),
                            class: "overflow-auto max-h-71",
                            onSelected: memberSelected
                        }, null, 8, ["users"]), [
                            [_directive_close_popover]
                        ])
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createVNode(TextField, {
                                ref_key: "userSelect",
                                ref: userSelect,
                                autocomplete: "off",
                                class: "tooltip-target",
                                "model-value": __props.searchTerm,
                                error: (emailError.value && _ctx.$t('errors.email.invalid')) ||
                                    (isSeatsAvailableErrorVisible.value && _ctx.$t('errors.unavailable_seats')),
                                label: _ctx.$t('teammate_email'),
                                placeholder: __props.disallowExternalToWorkspacePlaceholder || __props.disallowExternalToWorkspace
                                    ? _ctx.$t('seats_unavailable_placeholder')
                                    : _ctx.$t('seats_available_placeholder'),
                                onBlur: handleBlur,
                                onEnter: addManually,
                                onFocus: handleFocus,
                                onInput: handleInput,
                                "onUpdate:modelValue": handleModelValue
                            }, null, 8, ["model-value", "error", "label", "placeholder"])
                        ])
                    ], undefined, true),
                    _: 1
                }, 8, ["popover-inner-class", "disabled", "open"])
            ]));
        };
    }
});
